import { root, id } from './destination-groups';

export const destinationGroups = {
  ...root,
  id: {
    ...id,
  },
};
